export class AdminCredential {
    constructor(
        public role: string,
        public username: string,
        public password: string
    ){}
}


// WEBPACK FOOTER //
// ./src/common/modules/admin/models/AdminCredential.ts